import SuppliersList from './SuppliersList'

export default {
  list: SuppliersList,
}
